import { render, staticRenderFns } from "./Article2Content.vue?vue&type=template&id=6d5e87c7&scoped=true"
var script = {}
import style0 from "./Article2Content.vue?vue&type=style&index=0&id=6d5e87c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5e87c7",
  null
  
)

export default component.exports